import { cn, LineIcon, PowerIcon, Switch, SwitchWidthLabel, HeaderStyles } from 'scbk-ui-web';

import { useAppContext } from 'scbk-services';

interface PageMainHeaderProps {
  isNew?: boolean;
  onHandleAlert?: () => void;
  onHandleSearchPanel?: () => void;
  onHandleLogout?: () => void;
  onToggleLargeText?: (mode: 'Y' | 'N') => void;
  isScrolled?: boolean;
}

const PageMainHeader = ({
  isNew,
  onHandleAlert,
  onHandleSearchPanel,
  onHandleLogout,
  onToggleLargeText,
  isScrolled = false,
}: PageMainHeaderProps) => {
  // 현재 편한뱅킹 모드
  const { seniorMode: currentSeniorMode } = useAppContext();

  /**
   * 큰 글씨 여부
   */
  const isLargeText = currentSeniorMode === 'Y';

  return (
    <header className={`${HeaderStyles['page-main-header']} ${isScrolled ? HeaderStyles.scrolled : ''}`}>
      <div className={HeaderStyles['page-main-header-wrap']}>
        <SwitchWidthLabel>
          <Switch
            id="large-text-mode"
            checked={isLargeText}
            onCheckedChange={(checked: boolean) => {
              onToggleLargeText && onToggleLargeText(checked ? 'Y' : 'N');
            }}
            data-cn="홈 Header"
            data-ac="편한뱅킹 전환"
            data-tx="편한뱅킹 사용하기"
          >
            <label>편한</label>
          </Switch>
        </SwitchWidthLabel>
        <div className={cn(HeaderStyles['page-main-inner'], 'com-box-shadow')}>
          <div className="relative h-6">
            <button
              aria-label="알림"
              onClick={(e) => {
                e.preventDefault();
                onHandleAlert && onHandleAlert();
              }}
              data-cn="홈 Header"
              data-ac="알림 확인"
              data-tx="알림 아이콘"
            >
              <LineIcon icoColor="bg-icon-basic-01" icoName="ico-alert" />
            </button>
            {isNew && (
              <span aria-label="새로운 소식" className={HeaderStyles['icon-new']}>
                <i aria-hidden="true" className="sr-only">
                  new
                </i>
              </span>
            )}
          </div>
          <button
            aria-label="검색"
            onClick={(e) => {
              e.preventDefault();
              onHandleSearchPanel && onHandleSearchPanel();
            }}
            data-cn="홈 Header"
            data-ac="검색 하기"
            data-tx="검색 아이콘"
          >
            <LineIcon icoColor="bg-icon-basic-01" icoName="ico-search" />
          </button>
        </div>
        <button
          className="com-box-shadow w-10 h-10 ml-2"
          aria-label="로그아웃"
          onClick={(e) => {
            e.preventDefault();
            onHandleLogout && onHandleLogout();
          }}
          data-cn="홈 Header"
          data-ac="계정 상태 전환"
          data-tx="logout"
        >
          <PowerIcon />
        </button>
      </div>
    </header>
  );
};

export { PageMainHeader };
